import React, { useState } from 'react';
// import DataFinder from "../HelperClasses/DataFinder";
import './AuctionWidget.css';
import { bidAuctionHandler } from '../../lib/api';
import { createLogger } from '../../utils/logger';

const log = createLogger('AuctionWidget');

// const calculatePnL = () => {
//     const pnlResults = DataFinder.getPositionData("12345").map(trade => {
//         const marketData = DataFinder.getStockInfo(trade.ticker);
//
//         if (!marketData) {
//             console.warn(`Market data not found for ticker: ${trade.ticker}`);
//             return { ...trade, pnl: 0 };
//         }
//
//         const marketPrice = marketData.price;
//         let pnl = 0;
//
//         if (trade.is_buy) {
//             pnl = (marketPrice - trade.price) * trade.quantity;
//         } else if (trade.is_sell) {
//             pnl = (trade.price - marketPrice) * trade.quantity;
//         }
//
//         return { ...trade, pnl: pnl.toFixed(2), result: (pnl > 0 ? "Profit" : "Loss") };
//     });
//
//     return pnlResults;
// };
//
// const pnlData = calculatePnL();
// const realizedPnL = pnlData.reduce((total, trade) => total + parseFloat(trade.pnl), 0);

const AuctionWidget = () => {
    const [inputValue, setInputValue] = useState('');
    const [, setSubscribeVar] = useState(true);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let raw = e.target.value;

        // Allow clearing the field while typing.
        if (raw === '') {
            setInputValue('');
            return;
        }

        // Strip leading zeros for integers ("05" -> "5"), but preserve decimals ("0.5").
        if (raw.length > 1 && raw.startsWith('0') && !raw.startsWith('0.')) {
            raw = raw.replace(/^0+/, '');
            if (raw === '') raw = '0';
        }

        // Disallow negative values.
        if (raw.startsWith('-')) {
            setInputValue('0');
            return;
        }

        setInputValue(raw);
    };

    const handleSubmit = () => {
        const bid = Number(inputValue);
        if (!Number.isFinite(bid) || bid <= 0) return;
        log.info('Auction bid submitted', { bid });
        bidAuctionHandler({ bid }, setSubscribeVar);
    };

    return (
        <div className="auction-widget">
            <div className="auction-widget-header">Auction</div>
            <div className="auction-widget-content">
                <input
                    type="number"
                    placeholder="Enter auction bid"
                    value={inputValue}
                    onChange={handleInputChange}
                    min="0"
                    className="auction-widget-input"
                />
                <button className="auction-widget-button" onClick={handleSubmit}>
                    Submit
                </button>
            </div>
        </div>
    );
};

export default AuctionWidget;
